/* Product fit scale: optional variant value, then product default. */
(function () {
  // Blocks can load this asset more than once.
  if (window.pfFitScaleInitialized) return;
  window.pfFitScaleInitialized = true;

  var states = new WeakMap();

  function clamp(value) {
    var number = Number(value);
    return Math.min(100, Math.max(0, Number.isFinite(number) ? number : 50));
  }

  function description(value) {
    if (value < 25) return 'Runs very small';
    if (value < 45) return 'Runs small';
    if (value <= 55) return 'True to size';
    if (value <= 75) return 'Runs large';
    return 'Runs very large';
  }

  function init(scale) {
    var state = states.get(scale);
    if (state) return state;
    var data = scale.querySelector('[data-fit-variants]');
    var variants;
    try {
      variants = JSON.parse(data ? data.textContent : '{}');
    } catch (error) {
      variants = {};
    }
    state = { variants: variants, value: null };
    states.set(scale, state);
    requestAnimationFrame(function () {
      if (scale.isConnected) scale.classList.add('is-ready');
    });
    return state;
  }

  function selectedVariantId(scale, variants) {
    var scope = scale.closest('.shopify-section') || scale.parentElement;

    // Horizon-style pickers expose the resolved variant on each option.
    // Prefer the checked picker over a potentially stale add-to-cart input.
    var selections = scope.querySelectorAll(
      'variant-picker input[type="radio"]:checked[data-variant-id], ' +
      'variant-picker select option:checked[data-variant-id]'
    );
    for (var selectionIndex = selections.length - 1; selectionIndex >= 0; selectionIndex--) {
      var selectedId = selections[selectionIndex].dataset.variantId;
      if (Object.prototype.hasOwnProperty.call(variants, selectedId)) return selectedId;
    }

    // Other themes submit the selected variant through an add-to-cart form.
    // Re-query because section rendering can replace both forms and pickers.
    var parentForm = scale.closest('form[action*="/cart/add"]');
    var inputs = parentForm
      ? parentForm.querySelectorAll('[name="id"]')
      : scope.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) continue;
      if (Object.prototype.hasOwnProperty.call(variants, input.value)) return input.value;
    }
    return scale.dataset.fitInitialVariant;
  }

  function sync(scale) {
    var state = init(scale);
    var variantId = selectedVariantId(scale, state.variants);
    var override = state.variants[variantId];
    var fallback = scale.dataset.fitDefault;
    if (fallback === undefined) fallback = scale.dataset.fitValue;
    var value = clamp(override !== null && override !== undefined && override !== ''
      ? override : fallback);
    if (value === state.value) return;
    state.value = value;
    scale.dataset.fitValue = String(value);
    scale.style.setProperty('--pf-fit-value', value);
    scale.setAttribute('aria-label',
      'Product fit: ' + description(value) + '. Fit scale value ' + value +
      ' out of 100, where 0 is ' + (scale.dataset.fitLabelSmall || 'Runs Small') +
      ', 50 is ' + (scale.dataset.fitLabelTrue || 'True to Size') +
      ', and 100 is ' + (scale.dataset.fitLabelLarge || 'Runs Large') + '.');
  }

  function syncAll() {
    document.querySelectorAll('[data-fit-scale]').forEach(sync);
  }

  function start() {
    syncAll();
    document.addEventListener('change', function () {
      requestAnimationFrame(syncAll);
    });
    document.addEventListener('shopify:section:load', syncAll);
    // Theme-independent fallback: hidden variant inputs often update without
    // emitting a change event. Also discovers scales replaced by section renders.
    window.setInterval(function () {
      if (!document.hidden) syncAll();
    }, 200);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) syncAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
